import { moduleBrokerName } from '../module-params';

export const changePageTitle = (title) => {
  let newTitle = 'Quantiply Admin Panel';

  if (title) {
    newTitle = title;
  }

  document.title = newTitle;
};

function capitalizeFirstLetter(text) {
  if (!text) return text; // handle empty/null
  return text.charAt(0).toUpperCase() + text.slice(1);
}

export const changePageTitleModifierBrokerWise = () => {
  if (!moduleBrokerName) {
    changePageTitle('Quantiply Admin Panel');
    return;
  }

  let brokerName = capitalizeFirstLetter(moduleBrokerName);

  if (moduleBrokerName === 'angel') {
    brokerName = 'AngelOne';
  }

  changePageTitle(`${brokerName} Admin Panel`);
};
